import { useMutation } from '@tanstack/react-query';
import supabase from 'sdk/api';

const updateShippingAddressById = async (newAddress: any, id) => {
    const { data: updateData, error: updateError } = await supabase
        .from('user_shippings')
        .update({
            city: newAddress?.city,
            street: newAddress?.street,
            apartment: newAddress?.apartment,
            zip_code: newAddress?.zip_code,
            state: newAddress?.state,
            country: newAddress?.country,
        })
        .eq('id', id);

    if (updateError) {
        throw new Error(updateError.message);
    }

    return updateData;
};

export default function useUpdateShippingAddressById() {
    return useMutation(({ newAddress, id }: { newAddress: any, id }) => updateShippingAddressById(newAddress, id), {
        onSuccess: async (data) => data,
    });
}
